import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const TowerOfHanoi = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Tower Of Hanoi"
    videos={[
      "https://www.youtube.com/embed/q6RicK1FCUs"
    ]}
    takeaways={[
      { text: "Direct question: learn the pseudo code and implementation." }
    ]}
    questions={[
      "Write an algorithm to solve the following puzzle. Derive a recurrence relation for the algorithm and analyze the time complexity of the algorithm using back substitution method. Consider three rods and N disks of various diameters, which can slide onto any rod. The puzzle begins with the disks stacked on one rod in the order of decreasing size, the smallest at the top, thus approximating a conical shape. The objective of the puzzle is to move the entire disks to the last rod, obeying the following rules:\n1. Only one disk may be moved at a time.\n2. Each move consists of taking the upper disk from one of the stacks and placing it on top of another stack or on an empty rod.\n3. No disk may be placed on top of a disk that is smaller than it."
    ]}
    exampleVideos={[]}
  />
);
}

export default TowerOfHanoi;
